import React from "react";

export type SortOrder = "asc" | "desc" | "none";

type Props<F extends string> = {
    field: F;
    activeField: F;
    order: Exclude<SortOrder, "none">;
    onSort: (field: F) => void;
    children: React.ReactNode; // label
    className?: string;
    thProps?: React.ThHTMLAttributes<HTMLTableCellElement>;
};

/** A11y-friendly sortable header cell with icon and aria-sort */
export default function TableSortHeader<F extends string>({
                                                              field,
                                                              activeField,
                                                              order,
                                                              onSort,
                                                              children,
                                                              className = "",
                                                              thProps,
                                                          }: Props<F>) {
    const isActive = activeField === field;
    const ariaSort: "none" | "ascending" | "descending" = !isActive
        ? "none"
        : order === "asc"
            ? "ascending"
            : "descending";

    return (
        <th
            aria-sort={ariaSort}
            className={`px-3 py-3.5 text-left text-sm font-semibold text-blue-900 ${className}`}
            {...thProps}
        >
            <button
                type="button"
                onClick={() => onSort(field)}
                className="inline-flex items-center gap-1 text-left hover:text-gray-700"
            >
                <span>{children}</span>
                <span aria-hidden className="text-gray-400">
          {!isActive ? "" : order === "asc" ? "▲" : "▼"}
        </span>
            </button>
        </th>
    );
}
